import { makeTypographyComponent } from '../../../../internal/typography/makeTypographyComponent';
export function makeUIText(variantProps) {
  return makeTypographyComponent({
    hardProps: variantProps,
    defaultProps: {
      as: 'span',
      display: 'block',
      color: 'text-primary-default',
      fontWeight: 'normal'
    },
    displayName: 'UIText'
  });
}